import {
  BR_STATUS,
  getItemStatusCode,
} from '../../../../constants/brStatus';

/**
 * 管理端「继续」按钮状态机（单一出口）。
 * - visible：可点（人工审批中 PA 默认，或本会话用户已改草稿）
 * - hidden：不展示（已处理锁 / 非 PA 默认）
 *
 * 规则（供應商中心 KYB）：
 * - 审批中(P)：等阿里云机器审 → 整栏操作区不展示（见 shouldShowAdminActions）
 * - 人工审批中(PA)：可人工操作 → 默认显示 Proceed
 *
 * @param {object|string|number} itemOrId
 * @param {{ proceedLockedIds?: object, proceedUnlockedIds?: object }} session
 * @returns {'visible'|'hidden'}
 */
export function getProceedButtonState(itemOrId, session = {}) {
  const item = itemOrId && typeof itemOrId === 'object' ? itemOrId : null;
  const approvalId = item ? item.approvalId : itemOrId;
  if (approvalId == null || approvalId === '') {
    return 'hidden';
  }
  const key = String(approvalId);
  const unlocked = session.proceedUnlockedIds || {};
  const locked = session.proceedLockedIds || {};
  if (unlocked[key]) {
    return 'visible';
  }
  if (locked[key]) {
    return 'hidden';
  }
  if (!item) {
    return 'hidden';
  }
  const code = getItemStatusCode(item);
  // 人工审批中：默认显示 Proceed
  if (code === BR_STATUS.PENDING_MANUAL) {
    return 'visible';
  }
  // 审批中(P) 操作栏本身不展示；其它非待审默认隐藏
  return 'hidden';
}

export function isProceedButtonVisible(itemOrId, session = {}) {
  return getProceedButtonState(itemOrId, session) === 'visible';
}
